<ng-container>
  <div class="edit-employee-wrapper">
    <p>{{ 'myAccount.userDetails' | cxTranslate }}</p>
    <div class="left-section" [ngClass]="{ 'is-admin': isAdmin }">
      <app-dynamic-form
        (formGroupEmit)="updateFormGroup($event)"
        (formModelEmit)="updateFormModel($event)"
        [emitOnInit]="true"
        [formGroupId]="'EDIT_EMPLOYEE'"
        [static]="false"
        [activeLanguage]="activeLanguage$ | async"
      ></app-dynamic-form>
    </div>
  </div>

  <ng-container *ngIf="accountPermissionsEnabled">
    <app-myaccount-employee-address
      (activeAddresses)="activeAddresses($event)"
      (addressHasChanged)="hasChanged($event)"
      (isAddressSelected)="hasAddressSelected($event)"
    ></app-myaccount-employee-address>
    <app-myaccount-permissions (activePermission)="activePermission($event)" (permissionsChanged)="hasChanged($event)">
    </app-myaccount-permissions>
  </ng-container>

  <div class="add-button-wrapper">
    <div class="main-btn-wrapper">
      <button [routerLink]="'/my-account'" mat-button class="btn secondary-btn">
        {{ 'common.cancel' | cxTranslate }}
      </button>
      <button
        mat-button
        class="btn primary-btn"
        [ngClass]="activeLanguage$ | async"
        (click)="onSubmit($event, 'submit')"
        [disabled]="buttonNoUpdate || !isAddressSelected || !formGroup?.valid"
      >
        {{ 'common.save' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>
